import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SubscribedContainer } from '../../util/subscribed-container';
import { IBaryInput } from '../../../../models/bary-input';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { Address } from '../../../../models/address.model';
import { BillAddressFormGroup } from '../../../../models/forms/BillAddressFormGroup';
import { AddressFormGroup } from '../../../../models/forms/AddressFormGroup';

@Component({
  selector: 'jhi-wepal-input-gplace',
  templateUrl: './wepal-input-gplace.component.html',
  styleUrls: ['./wepal-input-gplace.component.scss'],
})
export class WepalInputGplaceComponent extends SubscribedContainer implements OnInit, IBaryInput {
  @Input() id = '';
  @Input() label: string | undefined;
  @Input() icon: string | undefined;
  @Input() name: string | undefined;
  @Input() class = '';
  @Input() disabled = false;
  @Input() verify = true;
  @Input() addressForm!: AddressFormGroup | BillAddressFormGroup;
  @Input() placeholder: string | undefined;
  @Input() direction: 'left' | 'right' | 'all' | 'none' = 'none';

  @Output() setAddressEvent = new EventEmitter<any>();
  @Output() updateAddressEvent = new EventEmitter<any>();
  control: FormControl = new FormControl();
  validAddress = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  setAddress(address: Address): void {
    this.addressForm.updateForm(address);
    this.control.setValue(this.addressForm.controls.autofill.value);
    this.validAddress = true;
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.control.setValue(this.addressForm.controls.autofill.value);
  }
}
